import React from 'react';
import { Building2, House, Users, Key } from 'lucide-react';
import { Property } from '@/stores/useLandlordStore';
import { PortalCard } from '@/components/cards/PortalCard';

interface LandlordPropertyCardProps {
  property: Property;
  onClick?: () => void;
  selected?: boolean;
}

export const LandlordPropertyCard: React.FC<LandlordPropertyCardProps> = ({
  property,
  onClick,
}) => {
  const stats = property.unit_stats || { total: 0, occupied: 0, available: 0 };

  return (
    <PortalCard
      title={property.name}
      subtitle={property.address}
      icon={Building2}
      iconBg="bg-light-bg dark:bg-dark-bg"
      iconColor="text-light-subtle dark:text-dark-subtle"
      stats={[
        { icon: House, label: `${stats.total} units` },
        { icon: Users, label: `${stats.occupied} full` },
        { icon: Key,   label: `${stats.available} empty` },
      ]}
      onClick={onClick}
    />
  );
};
